import { Component, Output, EventEmitter, Input, signal, effect, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { formatApiUtcDateTime } from '@shared/helpers/date-format.helper';
import * as moment from 'moment';

@Component({
  selector: 'daterangepicker-v2',
  templateUrl: './date-rangepicker-v2.component.html',
  styleUrls: ['./date-rangepicker-v2.component.scss']
})
export class DateRangePickerV2Component implements OnInit {
  dateControl: UntypedFormControl = new UntypedFormControl();

  @Input() title: string = null;
  @Input() disabled: boolean = false;
  @Input() form: UntypedFormGroup;
  @Input() clearable: boolean = true;
  @Input() hasError: boolean = false;
  @Input() controlStart: string = 'start';
  @Input() controlEnd: string = 'end';

  @Output() rangeChanged: EventEmitter<{ start: moment.Moment; end: moment.Moment }> = new EventEmitter();

  protected startInput = new FormControl();
  protected endInput = new FormControl();

  private startDate = signal<Date | null>(null);
  private endDate = signal<Date | null>(null);

  get controlStartValue(): string {
    return this.form?.get(this.controlStart).value;
  }

  get controlEndValue(): string {
    return this.form?.get(this.controlEnd).value;
  }

  constructor() {
    effect(() => {
      const start = this.startDate();
      const end = this.endDate();
      if (start && end) {
        this.dateControl.setValue(
          `${moment(start).format('DD.MM.YYYY')} - ${moment(end).format('DD.MM.YYYY')}`
        );
        this.rangeChanged.emit({ start: moment(start), end: moment(end).endOf('day') });
      }
    });
  }

  ngOnInit(): void {
    if (this.controlStartValue && this.controlEndValue) {
      this.dateControl.setValue(
        `${moment(this.controlStartValue).format('DD.MM.YYYY')} - ${moment(this.controlEndValue).format('DD.MM.YYYY')}`
      );
    }
  }

  updateStartDate({ value }: MatDatepickerInputEvent<any>): void {
    this.startDate.set(value);
    const start = formatApiUtcDateTime(value);
    this.form?.get(this.controlStart).setValue(start);
  }

  updateEndDate({ value }: MatDatepickerInputEvent<any>): void {
    this.endDate.set(value);
    const end = formatApiUtcDateTime(value, { endOfDay: true });
    this.form?.get(this.controlEnd).setValue(end);
  }

  setRange(startDate: string, endDate: string): void {
    if (!startDate || !endDate) return;

    this.startInput.setValue(startDate);
    this.endInput.setValue(endDate);
  }

  resetValue(): void {
    this.startDate.set(null);
    this.endDate.set(null);
    this.startInput.setValue(null);
    this.endInput.setValue(null);
    this.dateControl.setValue(null);
    this.form?.get(this.controlStart).setValue(null, { emitEvent: false });
    this.form?.get(this.controlEnd).setValue(null, { emitEvent: false });
    this.rangeChanged.emit({ start: null, end: null });
  }
}
